module.exports = __webpack_public_path__ + "static/img/Illustration.b105370.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Illustration.png
// module id = i/XM
// module chunks = 1